/*
  Comportements du site (portés de src/scripts/main.ts du site Astro).
  Le site est multipage : tout s'initialise une seule fois, au chargement.
  Chaque module tolère l'absence de ses éléments dans la page.
*/
import { initCalendly } from './modules/calendly';
import { initContactDrawer } from './modules/contact-drawer';
import { initCurtain } from './modules/curtain';
import { revealFonts } from './modules/fonts';
import { initMenu } from './modules/menu';
import { initParallax } from './modules/parallax';
import { scrollToInitialHash } from './modules/scroll';
import { initScrollSpy } from './modules/scroll-spy';
import { initBackgroundVideos } from './modules/videos';

function init() {
  const fontsReady = revealFonts().then(() => {
    // arrivée avec un hash (ex. /#about depuis une autre page) : se placer sur
    // la cible une fois la mise en page stabilisée par la police
    scrollToInitialHash();
  });

  initMenu();
  initContactDrawer();
  initCalendly();
  initBackgroundVideos();
  initParallax();
  initScrollSpy();
  initCurtain(fontsReady);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
